angular.module('picmonicng').directive('myPicmonicsBlock', [
  function () {
    return {
      restrict: 'E',
      templateUrl: '/templates/directives/my-picmonics-block.html',
      controller: [
        '$scope',
        'UserPicmonicService',
        '$rootScope',
        'ngBowser',
        function ($scope, UserPicmonicService, $rootScope, ngBowser) {
          $scope.loading = true;
          $scope.UserPicmonicService = UserPicmonicService;
          $scope.isDesktop = ngBowser.isDesktop();

          $scope.getMyPicmonics = function () {
            $scope.total_mastered = 0;
            UserPicmonicService.getPicmonics()
              .$promise.then(function () {
                $scope.numFacts = 0;
                angular.forEach(UserPicmonicService.picmonics.data, function (picmonic) {
                  $scope.numFacts += picmonic.num_facts;
                  if (
                    picmonic.num_mastered_facts &&
                    picmonic.num_facts &&
                    picmonic.num_mastered_facts >= picmonic.num_facts
                  ) {
                    $scope.total_mastered++;
                  }
                });
              })
              .finally(function () {
                $scope.loading = false;
              });
          };
          $scope.getMyPicmonics();

          // Listen for data change event
          $scope.$on('myCardDataChanged', function () {
            $scope.getMyPicmonics();
          });
        },
      ],
    };
  },
]);
